import { Component, OnInit } from '@angular/core';
import { debug } from 'util';
import { VideoCallService } from '../video-call.service';


@Component({
  selector: 'app-get-help',
  templateUrl: './get-help.component.html',
  styleUrls: ['./get-help.component.css']
})
export class GetHelpComponent implements OnInit {

  public username: string;
  public password: string;

  public receiver: string;

  constructor(private service: VideoCallService) { }

  ngOnInit() {
  }

  initCall() {
    this.service.initCall(this.username, this.password, this.receiver).subscribe(res => (window.open(res.data[0])));
  }

}
